// extracted by mini-css-extract-plugin
export default {"content":"MessageLine_content__oYmp0"};